import * as React from "react";

import { useMediaRange } from "./useMediaRange";
import { useMediaQuery } from "./useMediaQuery";

export type OnlyProps<
  OtherProps = { [prop: string]: never },
> = OtherProps & {
  matchMedia?: string;
  on?: string;
  as?: string | React.ComponentType<OtherProps>;
};

export function Only<
  OtherProps = { [prop: string]: never },
>({
  matchMedia,
  on,
  as,
  children,
  ...props
}: React.PropsWithChildren<
  OnlyProps<OtherProps>
>): React.ReactElement | null {
  const matchOn = useMediaRange(on);
  const matchQuery = useMediaQuery(matchMedia || "-");
  const isShown = matchOn || matchQuery;

  if (!isShown) {
    return null;
  }

  return React.createElement(
    // @ts-expect-error – this is a complex type
    as || React.Fragment,
    as ? (props as OtherProps) : undefined,
    children,
  );
}
